<template>
<div>
  <div class="main">
    <div class="plk-app" v-show="isApp">
      <!-- <div class="plk-app-logo">e普惠</div> -->
      <div class="plk-app-logo">
        <img src="../assets/img/zkjy-icon.png" alt="">
      </div>
      <div class="plk-app-title">
        <span>中科名兽医APP</span>
        <strong>数字化兽医开拓者</strong>
      </div>
      <div class="plk-app-right">
        <div class="plk-app-open">
          <template v-if="openPopup == true">
              <div class="app-open">打开APP</div>
              <wx-open-launch-app class="launch-btn" :id="id" :appid="appid" :extinfo="wechatOpenAppData">
                <script type="text/wxtag-template">
                <style>.btn {height: 45px;}</style>
                <div class="btn">打开APP</div>
                </script>
              </wx-open-launch-app>
          </template>
          <div class="app-open" v-else @click="downloadapp">下载APP</div>
        </div>
        <div class="plk-app-close" @click="closeApp">
          <img src="../assets/img/Delete@3x.png" alt="">
        </div>
      </div>
    </div>
    <div class="plk-app-height" v-show="isApp"></div>
    <div class="plk-img-swiper">
      <cube-slide :initial-index="1" :data="bannerList" ref="slide">
        <cube-slide-item v-for="(item, index) in bannerList" :key="index" @click.native="clickHandler(item, index)">
          <img :src="item">
        </cube-slide-item>
      </cube-slide>
    </div>
    <div class="plk-ordinary" v-show="itId">
      <div class="ordinary-left">¥{{retailPrice | priceFloat}}</div>
      <div class="ordinary-right">成交量:{{salesTotal}}</div>
    </div>
    <div class="plk-ordinary" v-show="cpId">
      <div class="ordinary-left1">
        <strong>¥{{preferentialPrice}}</strong>
        <span>¥{{retailPrice}}</span>
      </div>
      <div class="ordinary-right">成交量:{{salesTotal}}</div>
    </div>
    <div class="plk-title">
      <div class="plk-goodsName">{{goodsName}}</div>
      <div class="plk-commonName" v-if="itId">通用名称: {{commonName}}</div>
    </div>
    <!-- 满赠 -->
    <div class="full-gift-box" v-if="present">
      <div class="full-gift-wrap">
        <div class="full-title">
          <img src="../assets/img/full-icon.png" />
          <span>{{present.title}}</span>
        </div>
        <div class="full-goods">
          <div v-for="(item,index) in present.goodList" :key="index" class="full-goods-wrap">
            <img :src="item.picture"/>
            <div class="full-goods-details">
              <p class="name">康感双黄连可溶性粉，乳酸环丙沙星乳酸环丙沙康感双黄连可溶性粉，乳酸环丙沙星乳酸环丙沙星注射液（按环…星注射液（按环…</p>
              <div class="number-box">
                <span class="money">￥0.00</span>
                <span class="num">X2</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="plk-back-top">
      <div class="plk-securities">
        <div class="plk-securities-left">领券</div>
        <div class="plk-securities-right">
          <div class="securities" v-for="(item, index) in psCouponBos" :key="index">满{{item.sccAmount}}减{{item.sccPreferentialValue}}</div>
        </div>
      </div>
    </div> -->
    <!-- 专家信息 -->
    <div class="plk-back" v-if="cpId && user_name">
      <div class="expert-box">
        <div class="expert-img">
          <img :src="img_uri">
        </div>
        <div class="expert-content">
          <div class="expert-name">
            <div class="name">{{user_name}}</div>
            <div class="line">
              <!-- <span class="inline" v-if="video_if==1">在线</span>
              <span class="outline" v-else>在线</span> -->
            </div>
          </div>
          <div class="expert-label">
            <div class="expert-vocation">{{et_name}}</div>
            <div class="expert-year">从业{{dateNum}}年</div>
          </div>
          <div class="expert-text">
            <div class="title">在线坐诊专家</div>
            <div class="text">{{skills}}</div>
          </div>
          <div class="expert-type">
            <div class="type-title">擅长种类: <span v-for="(item,i) in classid" :key="i">{{item}},</span></div>
          </div>
          <div class="expert-ul">
            <div class="expert-li" v-for="(item,i) in treatment_skill" :key="i">{{item}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 组方信息 -->
    <div class="plk-back-bottom" v-if="cpId && bannerList[0]">
      <div class="plk-goodslist">
        <div class="goodslist-title">组方详情及用法用量</div>
        <div class="goodslist">
          <div class="goodslist-box" v-for="(item,i) in goodsList" :key="i">
            <div class="goodslist-img">
              <img :src="item.image">
            </div>
            <div class="goodslist-content">
              <div class="goodslist-title">{{item.goodsName}}</div>
              <div class="goodslist-pices">
                <span class="pices">¥{{item.price | priceFloat}}</span>
                <span class="num">x{{item.num}}</span>
              </div>
              <div class="goodslist-text">用法用量:{{item.dosage}}</div>
              <div class="goodslist-company">
                <img src="../assets/img/shop@2x.png">
                <span>{{item.storeName}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="plk-back" v-if="itId">
      <div class="plk-statement">
        <div class="plk-zpbz">
          <img src="../assets/img/zp@2x.png" alt="">
          <span>正品保证</span>
        </div>
        <div class="plk-jyps">
          <img src="../assets/img/jyps@2x.png" alt="">
          <span>假一赔十</span>
        </div>
      </div>
    </div>
    <template v-if="itId">
        <div class="plk-back-bottom" v-show="store">
        <div class="plk-store">
            <div class="store-logoImg">
            <img :src="logoImg" alt="">
            </div>
            <div class="store-text">
            <div class="store-name">{{stName}}</div>
            <div class="store-start">
                <div class="start" v-if="starClass == 1"><span>店铺星级</span>★☆☆☆☆</div>
                <div class="start" v-if="starClass == 2"><span>店铺星级</span>★★☆☆☆</div>
                <div class="start" v-if="starClass == 3"><span>店铺星级</span>★★★☆☆</div>
                <div class="start" v-if="starClass == 4"><span>店铺星级</span>★★★★☆</div>
                <div class="start" v-if="starClass == 5"><span>店铺星级</span>★★★★★</div>
            </div>
            </div>
        </div>
        </div>
    </template>
    <div class="plk-detail">
      <div class="detail-title">
          <span>商品详情</span>
          <b></b>
      </div>
      <div class="detail-img">
        <div v-for="(item, index) in detailList" :key="index">
          <img :src="item" alt="">
        </div>
      </div>
    </div>
    <div class="plk-height"></div>
    <div class="plk-buton">
      <div class="plk-float-buton" @click="downloadapp">下单购买药品送<span style="font-size:0.16rem;">免费问诊及检测</span></div>
    </div>
  </div>
</div>
</template>

<script>
import wx from 'weixin-js-sdk'
import mixUmeng from '@/mixins/mixUmeng'
import { iswx, result, wxshare } from '@/utils/utils.js'
// shopSeckill,shopCombination,wxShare
import { goodDetail,compreDetail,tmgetExpertDetail,goodEnable } from '@/api/resetApi.js'

export default {
  // mixins: [mixUmeng],
  name: 'detail',
  data() {
    return {
      isApp: true,
      store: true,
      itId: '',
      activityId: '',
      imgurl: '',
      desc: '我在中科名兽医上发现一个不错的商品，下单购买送免费问诊及检测',
      bannerList: [],

      pageNum: 1,
      pageSize: 3,

      activityEndTime: '',
      retailPrice: '',
      preferentialPrice: '',
      salesTotal: '',
      goodsName: '',
      commonName: '',
      organId: '',

      stName: '',
      starClass: '',
      logoImg: '',

      goodsList: [],
      goodsList1: [],
      detailList: [],
      psCouponBos: [],

      id: 'wxopenLanchAppId',
      appid: 'wxdc89dd9a7329fe47',
      wechatOpenAppData: '',
      json: {},
      openPopup: false,
      browser: {
        trident: navigator.userAgent.indexOf('Trident') > -1, //IE内核
        presto: navigator.userAgent.indexOf('Presto') > -1, //opera内核
        webKit: navigator.userAgent.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: navigator.userAgent.indexOf('Gecko') > -1 && navigator.userAgent.indexOf('KHTML') == -1, //火狐内核
        mobile: !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/AppleWebKit/), //是否为移动终端
        ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: navigator.userAgent.indexOf('iPhone') > -1 || navigator.userAgent.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
        iPad: navigator.userAgent.indexOf('iPad') > -1, //是否iPad
        webApp: navigator.userAgent.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
      },
      // 组方

      cpId:'',
      expertUserId:'',
      cpThumb:'',
      // 专家信息
      img_uri: '',
      user_name: '',
      et_name: '',
      dateNum: '',
      skills: '',
      treatment_skill: [],
      classid: [],
      present:{}
    }
  },
  created(){
    this.itId = this.$route.query.itId || ''
    this.cpId = this.$route.query.cpId || ''
    if(this.cpId){
        this.prescriptionDetail()
    }else if(this.itId){
        this.shopgeneral() // 普通
    }
    
    this.json = {
      "type": "goods",
      "itId": this.itId
    }
    this.wechatOpenAppData = JSON.stringify(this.json)
    if (iswx() === true) {
        let wechat = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
        let judgewechat = wechat[1].split('.')
        if (judgewechat[0]>=8) {
            this.openPopup = true
        } else if(judgewechat[0]>=7){
            if(judgewechat[1]>=0){
                this.text = judgewechat
            if(judgewechat[2]>=12){
                this.openPopup = true
                console.log("当前符合 h5 打开指定app")                    
            }
            }
        }
    }
  },
  mounted() {
    if (this.openPopup == true) {
      var btn = document.getElementById(this.id)
      btn.addEventListener('launch', e => {
        alert(JSON.stringify(this.wechatOpenAppData))
        console.log('success');
      });
      btn.addEventListener('error',  e => {
        this.text = e.detail.errMsg
        if (e.detail.errMsg == 'launch:fail') {
          window.location = 'http://t.cn/Aijv8II4'
        } else {
          this.$createToast({
            txt: e.detail,
            type: 'error'
          }).show()
        }
      });
    }
  },
  methods: {
    // 下载APP跳转链接
    downloadapp() {
      window.location.href = 'http://t.cn/Aijv8II4'
    },
    // 关闭头部下载APP链接
    closeApp() {
      this.isApp = false;
    },
    // 组方详情
    async prescriptionDetail() {
      let data = {
        cpId: this.cpId,
      }
      const res = await compreDetail(data)
      try {
        if (res.data.code === 200) {
          this.bannerList = res.data.data.bannerImages.map(item => item.url )
          this.preferentialPrice = res.data.data.cpPrice
          this.retailPrice = res.data.data.price
          this.salesTotal = res.data.data.salesCount
          this.goodsName = res.data.data.cpDesc
          this.goodsList = res.data.data.goods
          this.detailList = res.data.data.detailImages.map(item => item.url )
          this.expertUserId = res.data.data.expertUserId
          this.cpThumb = res.data.data.cpThumb
          this.expertinfo()
          wxshare(this.cpThumb,this.goodsName,this.desc)
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    // 专家详情
    async expertinfo() {
      const res = await tmgetExpertDetail({expertCustomerCode:this.expertUserId})
      try {
        if (res.data.code === 200) {
          this.img_uri = res.data.data.expertDetail.headUrl
          this.user_name = res.data.data.expertDetail.userName
          this.et_name = res.data.data.expertDetail.expertFieldDesc
          this.dateNum = res.data.data.expertDetail.yearNum
          this.skills = res.data.data.expertDetail.academicAchievement ? res.data.data.expertDetail.academicAchievement : '执业医师在线接诊/免费视频诊疗，专家经验丰富！'
          this.classid = res.data.data.expertDetail.adeptClass
          this.treatment_skill = res.data.data.expertDetail.adeptLabel
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    // 普通详情
    async shopgeneral() {
      let data = {
        itId: this.itId,
      }
      const res = await goodDetail(data)
      try {
        if (res.data.code === 200) {
          this.imgurl = res.data.data.generalInfo.pictureUrl
          this.retailPrice = res.data.data.generalInfo.retailPrice
          this.salesTotal = res.data.data.generalInfo.salesTotal
          this.bannerList = res.data.data.generalInfo.bannerList
          this.goodsName = res.data.data.generalInfo.goodsName
          this.commonName = res.data.data.generalInfo.commonName
          this.organId = res.data.data.generalInfo.organId
          this.detailList = res.data.data.generalInfo.detailList
          this.present = res.data.data.present // 满赠
          this.stName = res.data.data.store.stName
          this.starClass = res.data.data.store.starClass
          this.logoImg = res.data.data.store.logoImg
          
          wxshare(this.imgurl,this.goodsName,this.desc);
        //   this.shopenable(0)
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    // 优惠券
    async shopenable(type) {
      let data = {
        type: type,
        itId: this.itId,
        organId: this.organId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      const res = await goodEnable(data)
      console.log(res)
      try {
        if (res.data.code === 200) {
          this.psCouponBos = res.data.data.psCouponBos
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {}
    },
    
    /*======= 微信分享 ======*/
    async wxShare() {
      // let shareUrl = encodeURIComponent(window.location.href.split('#')[0]);
      // console.log('shareUrl=',shareUrl)
      const res = await wxShare()
      try {
        let that = this
        that.shareUrl = window.location.href;
        console.log('shareUrl=',that.shareUrl)
        if (res.data.code == 200) {
          let shareUrl1 = that.shareUrl;
          console.log('shareUrl2=',shareUrl1)
          let appId = res.data.data.appid;
          let timestamp = res.data.data.timestamp;
          let nonceStr = res.data.data.noncestr;
          let signature = res.data.data.signature;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: nonceStr, // 必填，生成签名的随机串
            signature: signature,// 必填，签名，见附录1
            jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            openTagList: ['wx-open-launch-app']
          });
          wx.ready(function(){
            let imgurl = that.imgurl;
            let title = that.goodsName;
            let desc = that.desc;
            wx.error(function(res){ // config 信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的 debug 模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名。
                // alert("errorMSG:"+res.errMsg);
            });

            wx.onMenuShareTimeline({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: shareUrl1, // 分享链接
                imgUrl: imgurl, // 分享图标
                success: function () {
                  // 用户确认分享后执行的回调函数
                  this.$createToast({
                    type: 'correct',
                    txt: '分享成功',
                    time: 1000
                  }).show()
                },
                cancel: function () {
                  // 用户取消分享后执行的回调函数
                  this.$createToast({
                    txt: '分享失败',
                    type: 'error'
                  }).show()
                }
            });

            wx.onMenuShareAppMessage({
                title: title, // 分享标题
                desc: desc, // 分享描述
                link: shareUrl1, // 分享链接
                imgUrl: imgurl, // 分享图标
                success: function () {
                  // 用户确认分享后执行的回调函数
                  this.$createToast({
                    type: 'correct',
                    txt: '分享成功',
                    time: 1000
                  }).show()
                },
                cancel: function () {
                  // 用户取消分享后执行的回调函数
                  this.$createToast({
                    txt: '分享失败',
                    type: 'error'
                  }).show()
                }
            });

          });
        } else {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      } catch (error) {
        console.log(error)
      }
    },
    clickHandler(item, index) {
      console.log(item, index)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.main {
  max-width: 768px;
  margin: 0 auto;
  .full-gift-box{
    padding: 0.1rem 0 0;
    background: #F7F7F7;
    .full-gift-wrap{
      background: #ffffff;
      padding: 0 0.1rem 0.1rem;
      .full-title{
        display: flex;
        align-items: center;
        padding: 0.12rem 0;
        img{
          width: 0.34rem;
          height: 0.18rem;
          margin-right: 0.06rem;
        }
        span{
          font-size: 0.14rem;
        }
      }
      .full-goods{
        .full-goods-wrap{
          display: flex;
          img{
            width: 1.1rem;
            height: 1.1rem;
            margin-right: 0.1rem;
          }
          .full-goods-details{
            width: 2.35rem;
            display: flex;
            flex-flow: column;
            justify-content: space-between;
            .name{
              font-size: 0.14rem;
              font-family: PingFangSC, PingFangSC-Medium;
              font-weight: 500;
              text-align: left;
              color: #333333;
              line-height: 0.2rem;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            .number-box{
              display: flex;
              justify-content: space-between;
              .money{
                font-size: 0.12rem;
                font-family: PingFangSC, PingFangSC-Medium;
                font-weight: 500;
                text-align: left;
                color: #fc3511;
                line-height: 0.18rem;
              }
              .num{
                font-size: 0.12rem;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                text-align: left;
                color: #9b9b9b;
                line-height: 0.18rem;
              }
            }
          }
        }
        
      }
    }
  }
  .plk-app {
    width: 3.75rem;
    height: 0.5rem;
    display: flex;
    background: linear-gradient(315deg,#096fcb, #2784f8);
    position: fixed;
    z-index: 9999;
    .plk-app-logo {
      flex: 0 0 0.4rem;
      margin-left: 0.1rem;
      align-self: center;
      height: 0.4rem;
      border-radius: 0.08rem;
      background: #fff;
      text-align: center;
      font-size: 0.14rem;
      font-weight: 400;
      color: rgba(234,71,71,1);
      line-height: 0.35rem;
      img {
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 0.05rem
      }
    }
    .plk-app-title {
      flex: 1;
      align-self: center;
      text-align: left;
      margin-left: 0.1rem;
      font-size: 0.14rem;
      font-weight: 400;
      color: rgba(255,255,255,1);
      line-height: 0.18rem;
      span {
        display: block;
      }
      strong {
        display: block;
      }
    }
    .plk-app-right {
      flex: 0 0 1.3rem;
      align-self: center;
      display: flex;
      .plk-app-open {
        position: relative;
        flex: 0 0 1rem;
        height: 0.3rem;
        line-height: 0.3rem;
        background: rgba(255,255,255,1);
        border-radius: 0.14rem;
        .app-open {
          text-align: center;
          font-size:  0.14rem;
          font-weight: 400;
          color: #127BE4;
        }
        .launch-btn {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          opacity: 0;
        }
      }
      .plk-app-close {
        flex: 0 0 0.12rem;
        height: 0.3rem;
        line-height: 0.3rem;
        margin-left: 0.05rem;
        align-self: center;
        img {
          vertical-align: top;
          margin-top: 0.08rem;
          width: 0.14rem;
          height: 0.14rem;
        }
      }
    }
  }
  .expert-box {
    display: flex;
    padding: 0.1rem;
    background: #fff;
    .expert-img {
      flex: 0 0 0.6rem;
      font-size: 0;
      img {
        width: 0.6rem;
        height: 0.6rem;
        border-radius: 50%;
      }
    }
    .expert-content {
      margin-left: 0.1rem;
      .expert-name {
        display: flex;
        .name {
          flex: 1;
          text-align: left;
          font-size: 0.16rem;
          font-weight: bold;
          color: #333;
        }
        .line {
          flex: 0 0 0.5rem;
          font-size: 0;
          .inline {
            display: inline-block;
            width: 0.5rem;
            height: 0.2rem;
            text-align: center;
            line-height: 0.2rem;
            font-size: 0.12rem;
            color: #fff;
            background: #21BE6C;
            border-radius: 0.2rem;
          }
          .outline {
            display: inline-block;
            width: 0.5rem;
            height: 0.2rem;
            text-align: center;
            line-height: 0.2rem;
            font-size: 0.12rem;
            color: #fff;
            background: #bebebe;
            border-radius: 0.2rem;
          }
        }
      }
      .expert-label {
        padding: 0.1rem 0;
        font-size: 0;
        text-align: left;
        .expert-vocation {
          display: inline-block;
          padding: 0.04rem 0.1rem;
          font-size: 0.12rem;
          color: #127BE4;
          border: 1px solid #127BE4;
          border-radius: 0.2rem;
          margin-right: 0.1rem;
        }
        .expert-year {
          display: inline-block;
          padding: 0.04rem 0.1rem;
          font-size: 0.12rem;
          color: #127BE4;
          border: 1px solid #127BE4;
          border-radius: 0.2rem;
        }
      }
      .expert-text {
        text-align: left;
        .title {
          padding-top: 0.05rem;
          font-size: 0.14rem;
          font-weight: bold;
          color: #181818;
        }
        .text {
          padding: 0.1rem 0;
          font-size: 0.12rem;
          color: #999;
        }
      }
      .expert-type {
        text-align: left;
        .type-title {
          font-size: 0.12rem;
          font-weight: bold;
          color: #181818;
        }
      }
      .expert-ul {
        padding-top: 0.1rem;
        text-align: left;
        font-size: 0;
        .expert-li {
          display: inline-block;
          padding: 0.05rem 0.1rem;
          margin: 0 0.02rem 0.05rem 0;
          font-size: 0.12rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: center;
          color: #127be4;
          background: rgba(18,123,228,0.1);
          border-radius: 0.1rem;
        }
      }
    }
  }
  .plk-app-height {
    height: 0.46rem;
  }
  .plk-img-swiper {
    width: 100%;
    height: 3rem;
    overflow: hidden;
    .cube-slide-item {
      text-align: center;
      img {
        max-width: 100%;
        height: 3rem;
        object-fit: cover;
      }
    }
  }
  .plk-ordinary {
    display: flex;
    height: 0.5rem;
    padding: 0 0.1rem;
    .ordinary-left {
      flex: 1;
      align-self: center;
      text-align: left;
      font-size: 0.16rem;
      color: #EA4747;
    }
    .ordinary-left1 {
      flex: 1;
      align-self: center;
      text-align: left;
      font-size: 0;
      strong {
        font-size: 0.18rem;
        color: #EA4747;
      }
      span {
        margin-left: 0.1rem;
        text-decoration: line-through;
        font-size: 0.1rem;
        color: #9B9B9B;
      }
    }
    .ordinary-right {
      flex: 0 0 1.2rem;
      align-self: center;
      text-align: right;
      font-size: 0.12rem;
      color: #9B9B9B;
    }
  }
  .plk-newgoods {
    display: flex;
    height: 0.5rem;
    padding: 0 0.1rem;
    background:linear-gradient(270deg,rgba(251,85,85,1) 0%,rgba(222,31,22,1) 100%);
    font-size: 0;
    .newgoods-img {
      flex: 0 0 0.34rem;
      align-self: center;
      img {
        width: 0.34rem;
        height: 0.34rem;
      }
    }
    .newgoods-left {
      flex: 1;
      margin-left: 0.1rem;
      align-self: center;
      text-align: left;
      strong {
        font-size: 0.16rem;
        color: #fff;
      }
      span {
        margin-left: 0.1rem;
        text-decoration: line-through;
        font-size: 0.1rem;
        color: #fff;
      }
    }
    .newgoods-right {
      flex: 0 0 1.2rem;
      align-self: center;
      text-align: right;
      font-size: 0.1rem;
      color: #fff;
    }
  }
  .plk-seckill {
    display: flex;
    height: 0.5rem;
    padding: 0 0.1rem;
    background:linear-gradient(270deg,rgba(251,85,85,1) 0%,rgba(222,31,22,1) 100%);
    font-size: 0;
    .seckill-img {
      flex: 0 0 0.34rem;
      align-self: center;
      img {
        width: 0.34rem;
        height: 0.34rem;
      }
    }
    .seckill-left {
      flex: 1;
      margin-left: 0.1rem;
      align-self: center;
      text-align: left;
      strong {
        font-size: 0.14rem;
        color: #fff;
      }
      .seckill-total {
        padding-top: 0.05rem;
        span {
          text-decoration: line-through;
          font-size: 0.1rem;
          color: #fff;
        }
        em {
          margin-left: 0.15rem;
          font-style: normal;;
          font-size: 0.1rem;
          color: #fff;
        }
      }
    }
    .seckill-right {
      flex: 0 0 1rem;
      align-self: center;
      .seckill-text {
        font-size: 0.1rem;
        color: #fff;
      }
      .seckill-time {
        padding-top: 0.05rem;
        font-size: 0.12rem;
        font-weight: bold;
        color: #fff;
      }
    }
  }
  .plk-limitBuy {
    display: flex;
    height: 0.5rem;
    padding: 0 0.1rem;
    background:linear-gradient(270deg,rgba(255,50,43,1) 0%,rgba(144,19,254,1) 100%);
    font-size: 0;
    .limitBuy-img {
      flex: 0 0 0.34rem;
      align-self: center;
      img {
        width: 0.34rem;
        height: 0.34rem;
      }
    }
    .limitBuy-left {
      flex: 1;
      margin-left: 0.1rem;
      align-self: center;
      text-align: left;
      strong {
        font-size: 0.14rem;
        color: #fff;
      }
      .limitBuy-total {
        padding-top: 0.05rem;
        span {
          text-decoration: line-through;
          font-size: 0.1rem;
          color: #fff;
        }
        em {
          margin-left: 0.15rem;
          font-style: normal;;
          font-size: 0.1rem;
          color: #fff;
        }
      }
    }
    .limitBuy-right {
      flex: 0 0 1rem;
      align-self: center;
      .limitBuy-text {
        font-size: 0.1rem;
        color: #fff;
      }
      .limitBuy-time {
        padding-top: 0.05rem;
        font-size: 0.12rem;
        font-weight: bold;
        color: #fff;
      }
    }
  }
  .plk-combination {
    display: flex;
    height: 0.5rem;
    padding: 0 0.1rem;
    background:linear-gradient(270deg,rgba(251,85,85,1) 0%,rgba(222,31,22,1) 100%);
    font-size: 0;
    .combination-img {
      flex: 0 0 0.34rem;
      align-self: center;
      img {
        width: 0.34rem;
        height: 0.34rem;
      }
    }
    .combination-left {
      flex: 1;
      margin-left: 0.1rem;
      align-self: center;
      text-align: left;
      strong {
        font-size: 0.14rem;
        color: #fff;
      }
      .combination-total {
        padding-top: 0.05rem;
        span {
          text-decoration: line-through;
          font-size: 0.1rem;
          color: #fff;
        }
        em {
          margin-left: 0.15rem;
          font-style: normal;;
          font-size: 0.1rem;
          color: #fff;
        }
      }
    }
    .combination-right {
      flex: 0 0 1rem;
      align-self: center;
      .combination-text {
        font-size: 0.1rem;
        color: #fff;
      }
      .combination-time {
        padding-top: 0.05rem;
        font-size: 0.12rem;
        font-weight: bold;
        color: #fff;
      }
    }
  }
  .plk-title {
    padding: 0 0.1rem;
    text-align: left;
    font-size: 0;
    .plk-goodsName {
      padding: 0.1rem 0;
      font-size: 0.12rem;
      color: #000;
    }
    .plk-commonName {
      padding-bottom: 0.1rem;
      font-size: 0.12rem;
      color:rgba(155,155,155,1);
    }
  }
  .plk-goodslist {
    padding: 0.1rem;
    background: #fff;
    .goodslist-title {
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      word-wrap: break-word;
      word-break:break-all;
      white-space: normal !important;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      height: 0.3rem;
      line-height: 0.3rem;
      text-align: left;
      font-size: 0.14rem;
      font-weight: bold;
      color: #181818;
    }
    .goodslist {
      text-align: left;
      .goodslist-box {
        display: flex;
        padding: 0.1rem 0;
        border-bottom: 0.01rem solid #ddd;
        &:last-child {
          border-bottom: 0;
        }
        .goodslist-img {
          flex: 0 0 1.1rem;
          height: 1.1rem;
          border: 0.01rem solid #F1F1F1;
          img {
            width: 1.1rem;
            height: 1.1rem;
          }
        }
        .goodslist-content {
          flex: 1;
          position: relative;
          margin-left: 0.1rem;
          .goodslist-title {
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            word-wrap: break-word;
            word-break:break-all;
            white-space: normal !important;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            height: 0.29rem;
            line-height: 0.15rem;
            text-align: left;
            font-size: 0.14rem;
            color: #000;
          }
          .goodslist-pices {
            display: flex;
            padding: 0.08rem 0 0.08rem;
            text-align: left;
            .pices {
              flex: 1;
              font-size: 0.14rem;
              color: #EA4747;
            }
            .num {
              flex: 1;
              text-align: right;
              font-size: 0.14rem;
              color: #9b9b9b;
            }
          }
          .goodslist-text {
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            word-wrap: break-word;
            white-space: normal !important;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            height: 0.3rem;
            line-height: 0.16rem;
            text-align: left;
            font-size: 0.12rem;
            color: #666;
          }
          .goodslist-company {
            width: 100%;
            position: absolute;
            bottom: 0;
            font-size: 0;
            img {
              width: 0.18rem;
              height: 0.18rem;
              vertical-align: middle;
            }
            span {
              margin-left: 0.05rem;
              font-size: 0.12rem;
              color: #181818;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }
  .plk-securities {
    display: flex;
    height: 0.5rem;
    background: #fff;
    .plk-securities-left {
      flex: 0 0 0.4rem;
      font-size: 0.1rem;
      font-weight: bold;
      align-self: center;
      color: #181818;
    }
    .plk-securities-right {
      flex: 1;
      align-self: center;
      text-align: left;
      font-size: 0;
      .securities {
        display: inline-block;
        margin-right: 0.05rem;
        padding: 0 0.1rem;
        width: 0.78rem;
        height: 0.4rem;
        background: url(../assets/img/juan@2x.png) no-repeat;
        background-size: 100% 100%;
        text-align: center;
        line-height: 0.4rem;
        font-size: 0.1rem;
        color: #EA4747;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
  }
  .plk-back {
    padding: 0.1rem 0;
    background: #F7F7F7;
  }
  .plk-back-bottom {
    padding-bottom: 0.1rem;
    background: #F7F7F7;
  }
  .plk-back-top {
    padding-top: 0.1rem;
    background: #F7F7F7;
  }
  .plk-statement {
    display: flex;
    padding: 0.14rem 0.1rem;
    background: #fff;
    font-size: 0;
    text-align: left;
    .plk-zpbz {
      flex: 0 0 1rem;
      vertical-align: middle;
      img {
        width: 0.18rem;
        height: 0.18rem;
        vertical-align: middle;
      }
      span {
        margin-left: 0.05rem;
        vertical-align: middle;
        font-size: 0.1rem;
        color: #181818;
      }
    }
    .plk-jyps {
      flex: 0 0 1rem;
      vertical-align: middle;
      img {
        width: 0.18rem;
        height: 0.18rem;
        vertical-align: middle;
      }
      span {
        margin-left: 0.05rem;
        vertical-align: middle;
        font-size: 0.1rem;
        color: #181818;
      }
    }
  }
  .plk-store {
    display: flex;
    padding: 0.1rem;
    background: #fff;
    font-size: 0;
    .store-logoImg {
      flex: 0 0 0.48rem;
      img {
        width: 0.48rem;
        height: 0.48rem;
      }
    }
    .store-text {
      flex: 1;
      position: relative;
      margin-left: 0.05rem;
      .store-name {
        text-align: left;
        font-size: 0.14rem;
        color: #181818;
      }
      .store-start {
        position: absolute;
        left: 0;
        bottom: 0;
        text-align: left;
        .start {
          font-size: 0.12rem;
          color: #EA4747;
          span {
            margin-right: 0.05rem;
            color: #818181;
          }
        }
      }
    }
  }
  .plk-detail {
    font-size: 0;
    text-align: center;
    .detail-title {
      display: flex;
      flex-direction: column;
      align-items: center;
    //   display: inline-block;
      padding: 0.1rem 0 0.05rem;
      font-size: 0.16rem;
      color: #181818;
      b{
            width: 61px;
            height: 4px;
            background: linear-gradient(270deg,#ffffff, #df2626);
            border-radius: 2px;
            margin-top: 6px;
      }
    //   border-bottom: 2px solid rgba(223,38,38,1);
    }
    .detail-img {
      padding-top: 0.1rem;
      img {
        width: 100%;
      }
    }
  }
  .plk-height {
    height: 0.45rem;
  }
  .plk-buton {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  .plk-float-buton {
    width: 3.75rem;
    height: 0.45rem;
    margin: 0 auto;
    background: linear-gradient(315deg,#096fcb, #2784f8);
    text-align: center;
    font-size: 0.14rem;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: rgba(255,255,255,1);
    line-height: 0.45rem;
  }
}
</style>